<div class="form-group">
  <ng-content></ng-content>
  <!-- For template-driven forms -->
  <ng-container *ngIf="displayErrorMessage && mainAccessor?.invalid && mainAccessor?.touched && displayErrors && !mainAccessor.hasError('emailTaken')">
    <div class="invalid-feedback">
      Please provide a valid {{label ? label : 'value'}}
    </div>
  </ng-container>
  <ng-container *ngIf="mainAccessor?.touched && mainAccessor?.hasError('emailTaken')">
    <div class="invalid-feedback">
      {{label ? label : 'value'}} address already in use
    </div>
  </ng-container>
</div>
